import { useState, createContext, useContext } from 'react';
import styled from '@emotion/styled';
import axios from '../../axios';

import { useTheme, Tab, Tabs, Breadcrumbs, Grid, Card, Avatar, Badge } from '@mui/material';

import { Container, StyledLink, BasicFlex } from '../../utils/Common';

import { useLocation, useParams } from 'react-router-dom';

import PhotoCameraFrontRoundedIcon from '@mui/icons-material/PhotoCameraFrontRounded';

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import LoadingPageComponent from '../../utils/utilities/LoadingPageComponent';

import { PageDataContext } from '../../contexts/PageData';

import { updateSettings, getSetting } from './apiService';

const ProfileBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.colors.darkBg};
  border-radius: .8rem;
  margin-bottom: 4.5rem;
`

const StyledAvatar = styled(Avatar)`
  position: relative;
  top: 4.5rem;
  border: 5px solid ${props => props.theme.colors.background.paper};
  box-sizing: border-box;
  width: 10rem;
  height: 10rem;
`;

const TabContentStyles = styled.div`
  margin-top: 2rem;
`;

const TabLabel = ({label, badge}) => {
  return (
    <BasicFlex gap="1rem">
      <span>{label}</span>
      {badge && <Badge badgeContent={badge} color="secondary" sx={{ position: "relative", top: "-.1rem", left: ".8rem" }} />}
    </BasicFlex>
  );
}

const TabContent = ({value, panel, children}) => {
  if (value !== panel) return <div></div>
  return <TabContentStyles>{children}</TabContentStyles>;
}
const SettingsLayout = ({ title, identifier = "details", tabs, tabContent, children, queryOptions = {}, url }) => {
  const [activeTab, setActiveTab] = useState(0);
  const location = useLocation();
  const { pathname } = location;
  const baseUrl = pathname.split('/view')[0];
  const { id } = useParams();

  const theme = useTheme();

  const queryClient = useQueryClient();

  const handleChangeTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  let panelName = tabContent?.[activeTab]?.panel;


  console.log(url, panelName, "url");

  const { mutate: updateSetting, isPending } = useMutation({
    mutationFn: updateSettings,
    // onSuccess: () => {
    //   queryClient.invalidateQueries([url, panelName]);
    // },
    onMutate: async (newSetting) => {
      let entry = Object.entries(newSetting?.data)[0];
      // Cancel any outgoing refetches so they don't overwrite our optimistic update
      await queryClient.cancelQueries({ queryKey: [url, panelName] });

      // Snapshot the previous value
      const previousSettings = queryClient.getQueryData([url, panelName]);

      // Optimistically update to the new value
      queryClient.setQueryData([url, panelName], (old) => ({
        ...old,
        [entry[0]]: entry[1]
      }));

      // Return context with the snapshotted value
      return { previousSettings };
    },
    
    // If the mutation fails, roll back to the previous value
    onError: (err, newSetting, context) => {
      queryClient.setQueryData([url, panelName], context.previousSettings);
    },
    
    // Always refetch after error or success to ensure consistency
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [url, panelName] });
    },
  })

  const modifySetting = (val, name, id) => {
    let data = { [name]: val };
    console.log(data, "data");
    updateSetting({ data, id });
  }

  const queryResult = useQuery({
    queryKey: [url, panelName],
    queryFn: () => getSetting(url, panelName),
    ...queryOptions,
    // enabled: false // for now
  });

  return (
    <PageDataContext.Provider value={{...queryResult, modifySetting, isPending}}>
    <Container>
      <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: '1rem' }}>
        <StyledLink to={baseUrl}>{title} Settings</StyledLink>
        {/* <StyledLink to={pathname}>View Settings</StyledLink> */}
        {/* <StyledLink to="#" $active={"true"}>{queryResult?.data?.[identifier]}</StyledLink> */}
      </Breadcrumbs>
          
       {queryResult.isLoading ? <LoadingPageComponent /> : <>
          {tabs?.length ? <Tabs value={activeTab} aria-label="basic tabs example" onChange={handleChangeTab}  sx={{borderBottom: "1px solid #DEDEDF", minHeight: "auto"}}>
            {tabs.map((tab, index) => (
              <Tab sx={{gap: '.5rem', padding: "1rem 3rem", minHeight: "auto"}} key={tab.label} label={<TabLabel label={tab.label} badge={tab.badge} />} icon={tab?.icon} iconPosition="start" />
            ))}
          </Tabs> : null}
          {tabs?.length && tabContent?.length ? tabContent.map((tab, index) => (
            <TabContent key={tab.panel} panel={index} value={activeTab} >{tab.content}</TabContent>)
          ) : null}

          {!tabs?.length ? children : null}
        </> }
    </Container>
    </PageDataContext.Provider>
  )
};

export default SettingsLayout;